// extracted by mini-css-extract-plugin
export var h = "styles-module--h--1781b";
export var h1 = "styles-module--h1--a3107";
export var h2 = "styles-module--h2--36586";
export var h3 = "styles-module--h3--97981";
export var primary = "styles-module--primary--f6315";
export var secondary = "styles-module--secondary--4f32d";
export var tertiary = "styles-module--tertiary--7c413";